const types = {
  SET_PAY_TOKEN: "SET_PAY_TOKEN",
};

const module = {
  namespaced: true,
  state: {
    payToken: ''
  },
  actions: {
    actionSetPayToken({ commit }, token) {
      commit(types.SET_PAY_TOKEN, token);
    },
  },
  mutations: {
    [types.SET_PAY_TOKEN](state, token = '') {
      state.payToken = token;
    },
  },
};

export default module;
